var _defs, _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeanTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a09f9f;\n      }\n\n      .cls-2 {\n        fill: #ececec;\n      }\n\n      .cls-3 {\n        fill: #65635f;\n      }\n\n      .cls-4 {\n        fill: #b1b1b0;\n      }\n\n      .cls-5 {\n        fill: #493522;\n      }\n\n      .cls-6 {\n        fill: #76614a;\n      }\n\n      .cls-7 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "485.27 747.54 60.13 614.69 600.97 519.35 1019.87 577.05 485.27 747.54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "201.95 411.35 362.29 336.52 840.87 320.23 840.87 330.93 689.56 396.32 232.43 416.86 201.95 411.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "366.85 678.63 366.85 685.44 832.32 569.8 832.32 562.98 366.85 678.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.85 678.63 832.32 562.98 827.17 561.26 366.85 674.51 366.85 678.63"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "692.77 392.34 215.29 414.68 215.85 422.9 692.77 398.27 692.77 392.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "689.56 539.94 694.71 539.3 694.71 394.1 689.56 394.1 689.56 539.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "684.41 537.79 689.56 539.94 689.56 394.1 684.41 395.55 684.41 537.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M831.95,333.19l-142.39,60.91h5.15l138.75-59.35c-.56-.46-1.07-.99-1.51-1.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "689.76 435.04 689.56 427.3 712.4 384.21 717.61 382.04 689.76 435.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "689.76 435.04 694.71 435.04 722.56 382.04 717.61 382.04 689.76 435.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M830.16,329.23l-145.74,63.47v3.87l147.55-63.37c-.9-1.16-1.54-2.52-1.8-3.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M736.45,372.81l-484.06,21.65-.13,2.97,476.3-20.8c2.48-1.59,5.13-2.75,7.89-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.64,378.78c1.21-1.04,2.48-1.92,3.79-2.69l-477.16,21.34-.13,2.97,472.69-20.64c.21-.35.47-.68.8-.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M790.44,349.09l-494.33,22.74-.13,2.97,486.46-21.85c2.72-1.18,5.39-2.44,7.99-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.77,352.37l-487.79,22.43-.13,2.97,478.37-21.48c3.21-1.25,6.41-2.52,9.55-3.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.71 626.96 227.71 633.77 689.56 539.85 689.56 533.04 227.71 626.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "227.71 626.96 689.56 533.04 684.41 531.31 227.71 622.85 227.71 626.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "317.35 608.69 322.5 608.05 322.5 411.45 317.35 411.45 317.35 608.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "312.19 606.53 317.35 608.69 317.35 411.45 312.19 412.9 312.19 606.53"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "473.8 346.73 322.5 411.45 317.35 411.45 468.65 346.73 473.8 346.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "317.55 452.39 317.35 444.65 340.18 401.56 345.39 399.38 317.55 452.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "317.55 452.39 322.5 452.39 350.35 399.38 345.39 399.38 317.55 452.39"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "312.19 413.92 312.19 410.05 468.65 341.92 468.65 346.73 312.19 413.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "413 589.14 418.15 588.5 418.15 407.23 413 407.23 413 589.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "407.85 586.98 413 589.14 413 407.23 407.85 408.68 407.85 586.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "569.46 342.5 418.15 407.23 413 407.23 564.31 342.5 569.46 342.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "413.2 448.17 413 440.42 435.84 397.33 441.05 395.16 413.2 448.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "413.2 448.17 418.15 448.17 446 395.16 441.05 395.16 413.2 448.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "407.85 409.7 407.85 405.83 564.31 337.7 564.31 342.5 407.85 409.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "497.88 572.05 503.03 571.41 503.03 403.19 497.88 403.19 497.88 572.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "492.73 569.89 497.88 572.05 497.88 403.19 492.73 404.64 492.73 569.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "654.34 338.47 503.03 403.19 497.88 403.19 649.19 338.47 654.34 338.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "498.09 444.13 497.88 436.39 520.72 393.3 525.93 391.13 498.09 444.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "498.09 444.13 503.03 444.13 530.89 391.13 525.93 391.13 498.09 444.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "492.73 405.66 492.73 401.79 649.19 333.66 649.19 338.47 492.73 405.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "596.54 552.01 601.7 551.37 601.7 398.49 596.54 398.49 596.54 552.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "591.39 549.86 596.54 552.01 596.54 398.49 591.39 399.94 591.39 549.86"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "753 333.77 601.7 398.49 596.54 398.49 747.85 333.77 753 333.77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "596.75 439.43 596.54 431.68 619.38 388.6 624.59 386.42 596.75 439.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "596.75 439.43 601.7 439.43 629.55 386.42 624.59 386.42 596.75 439.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "591.39 400.96 591.39 397.09 747.85 328.96 747.85 333.77 591.39 400.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.28 633.78 232.43 633.14 232.43 409.61 227.28 409.61 227.28 633.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "222.13 631.63 227.28 633.78 227.28 409.61 222.13 411.06 222.13 631.63"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.92 368.68 232.43 409.61 227.28 409.61 321.77 368.68 326.92 368.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.49 450.55 227.28 442.8 250.12 399.71 255.33 397.54 227.49 450.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "227.49 450.55 232.43 450.55 260.29 397.54 255.33 397.54 227.49 450.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "222.13 412.08 222.13 408.21 321.77 363.87 321.77 368.68 222.13 412.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "362.29 336.52 201.95 411.35 202.47 412.5 362.29 337.67 362.29 336.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.47 412.5 207.9 412.55 362.29 339.45 362.29 337.67 202.47 412.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "364.07 415.53 364.27 407.79 341.44 364.7 336.23 362.53 364.07 415.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "364.07 415.53 359.12 415.53 331.27 362.53 336.23 362.53 364.07 415.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "364.27 686.51 357.7 683.67 359.12 349.09 364.27 349.09 364.27 686.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "369.42 684.36 364.27 686.51 364.27 349.09 369.42 350.54 369.42 684.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "487.53 401.58 487.73 393.84 464.89 350.75 459.68 348.58 487.53 401.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "487.53 401.58 482.58 401.58 454.73 348.58 459.68 348.58 487.53 401.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "487.73 648.51 482.58 647.87 482.58 335.14 487.73 335.14 487.73 648.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "494.05 647.02 487.73 648.51 487.73 335.14 492.88 336.59 494.05 647.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "578.03 395.4 578.23 387.65 555.4 344.56 550.19 342.39 578.03 395.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "578.03 395.4 573.08 395.4 545.23 342.39 550.19 342.39 578.03 395.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "578.23 625.37 573.08 624.73 573.08 328.96 578.23 328.96 578.23 625.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "583.83 624.36 578.23 625.37 578.23 328.96 583.38 330.41 583.83 624.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "674.26 395.4 674.47 387.65 651.63 344.56 646.42 342.39 674.26 395.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "674.26 395.4 669.32 395.4 641.47 342.39 646.42 342.39 674.26 395.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "674.47 602.51 669.32 601.87 669.32 328.96 674.47 328.96 674.47 602.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "679.62 602.51 674.47 602.51 674.47 328.96 679.62 330.41 679.62 602.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "755.36 385.12 755.56 377.37 732.73 334.28 727.52 332.11 755.36 385.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "755.36 385.12 750.41 385.12 722.56 332.11 727.52 332.11 755.36 385.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M750.41,330.69v250.81l5.15.64v-252.33c-1.7.39-3.43.71-5.15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.56,329.81v252.33h5.15v-253.67c-1.64.46-3.37.94-5.15,1.34Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "810.97 344.37 806.87 343.8 832.11 391.86 832.32 384.12 810.97 344.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "806.87 343.8 802.88 345.63 827.17 391.86 832.11 391.86 806.87 343.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "832.32 562.98 827.17 561.26 827.17 325.42 832.32 325.42 832.32 562.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "837.47 568.72 832.32 569.8 832.32 325.49 837.47 326.94 837.47 568.72"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "362.29 349.8 207.9 422.9 207.9 412.55 362.29 339.45 362.29 349.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "207.9 422.9 362.29 349.8 367.21 352.33 215.85 422.9 207.9 422.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "849.29 331.85 362.31 349.8 362.31 339.45 849.29 321.49 849.29 331.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "849.29 331.85 362.31 349.8 360.19 355.58 839.74 337.62 849.29 331.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "849.29 319.67 362.31 337.63 362.31 339.45 849.29 321.49 849.29 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "849.29 318.68 362.31 336.52 362.31 337.63 849.29 319.67 849.29 318.68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeanTo);
export default __webpack_public_path__ + "static/media/lean-to.7896193b642b4b289f9a2caa57010833.svg";
export { ForwardRef as ReactComponent };